import { GlobalDisclaimerLevel, GlobalDisclaimerStoreValue, IGlobalDisclaimerStoreAddOptions } from '../models/disclaimers';
import { QueryStore } from './QueryStore';

export class GlobalDisclaimerStore {
	lastSuperscript: number = 0;
	values: GlobalDisclaimerStoreValue[] = [];
	subscribers: Function[] = [];
	subscribe(subscriber: () => void) {
		if (!this.subscribers) {
			this.subscribers = [];
		}
		this.subscribers.push(subscriber);
	}
	publish() {
		if (this.subscribers && this.subscribers.length > 0) {
			this.subscribers.forEach((subscriber) => {
				if (subscriber && typeof subscriber === 'function') {
					subscriber();
				}
			});
		}
	}
	add(appKey: string, responseContext: any, queryStore: QueryStore, ...optionsParams: IGlobalDisclaimerStoreAddOptions[]): GlobalDisclaimerStoreValue[] {
		const response: Set<GlobalDisclaimerStoreValue> = new Set();
		if (!this.values) {
			this.values = [];
		}
		for (const options of optionsParams) {
			// Add text logic in here too
			const { disclaimerType, textQuery = {} } = options;
			if (textQuery) {
				const text = GlobalDisclaimerStoreValue.getText(queryStore, disclaimerType, textQuery, responseContext);
				// SETUP NEW COMPOSITE KEY WITH TYPE AND TEXT
				if (text && text.length > 0) {
					const compositeKey = `${disclaimerType}_${text}`;

					const existing = this.values.find(value => value.key === compositeKey);
					if (existing) {
						existing.addApp(appKey, options);
						response.add(existing);
					}
					else {
						const value = new GlobalDisclaimerStoreValue(queryStore, ++this.lastSuperscript, compositeKey, responseContext, appKey, options);
						this.values.push(
							value,
						);
						response.add(value);
					}
					if (this.values.length > 0) {
						this.publish();
					}
				}
			}
		}
		return Array.from(response);
	}
	get(level: GlobalDisclaimerLevel, appKey?: string) {
		return this.values.filter(value => value.matches(level, appKey)).sort((a: GlobalDisclaimerStoreValue, b: GlobalDisclaimerStoreValue) => {
			return a.superscript - b.superscript;
		});
	}
	clear() {
		this.values = [];
		this.publish();
	}
}